import { SuperDate, getObjectPropByString } from '@razlet/utils';

const TYPE_KEYS = {
  FBL: {
    at: 'sentAt',
    from: 'sentBy',
  },
  FFM: {
    at: 'receivedAt',
    from: 'receivedFrom',
  },
  FSU: {
    at: 'receivedAt',
    from: 'receivedFrom',
  },
};

export default class CimpInfo {
  type = '';

  from = '';

  at = '';

  constructor (data, cimpType) {
    if (!data || !cimpType) return;

    this.type = cimpType;
    const key = TYPE_KEYS[this.type];

    this.at = new SuperDate(getObjectPropByString(data, key?.at));
    this.from = getObjectPropByString(data, key?.from);
  }

  get fromName () {
    if (!this.from) return '';
    return this.from.username || this.from;
  }
}
